<template>
  <div class="r-ph-16 r-pv-16">
    <h2>Soru Arşiv</h2>

    <!-- 
		// Ay / Yıl seçimleri (Arşiv temel filtreleri) - year-months select'e taşındı
		<div class="r-flx r-mb-12" style="gap:8px; align-items:center;">
			<label>Ay:</label>
			<select v-model="workMonth" @change="loadList">
				<option v-for="m in months" :key="m" :value="m">{{ m }}</option>
			</select>
			<label>Yıl:</label>
			<select v-model="workYear" @change="loadList">
				<option v-for="y in years" :key="y" :value="y">{{ y }}</option>
			</select>
		</div>
		-->

    <!-- Ortak FilterBar bileşeni ile Soru Çeşidi / Branş / Kitap Türü / Kitap + dinamik soru etiketleri -->
    <filter-bar
      ref="filterBarRef"
      :show-first-row="true"
      :show-filter-button="false"
      :show-dynamic-properties="true"
      :is-loading="isLoading"
      @property-change="onDynamicPropertyChange"
    >
      <!-- 1. satır: Soru Çeşidi + Branş -->
      <template #first-row>
        <r-select
          v-model="selectedYearMonth"
          label="Yıl / Ay"
          :data="yearMonthOptions"
          txt="txt"
          val="val"
          width="18%"
          @change="onYearMonthChange"
        />
        <r-select
          v-model="questPart"
          label="Soru Çeşidi"
          :data="questPartOptions"
          txt="txt"
          val="val"
          width="18%"
          @change="onQuestPartChange"
        />
        <r-select
          v-model="branchId"
          label="Branş"
          :data="branchOptions"
          txt="title"
          val="id"
          width="22%"
          style="color: rgb(17, 17, 17)"
          @change="onBranchChange"
        />
        <r-select
          v-model="subCategoryId"
          label="Alt Kategori"
          :data="subCategoryOptions"
          txt="title"
          val="id"
          width="22%"
          style="color: rgb(17, 17, 17)"
          :disabled="!branchId"
        />
      </template>

      <template #actions>
        <r-select
          v-model="noteCategoryId"
          label="Kitap Türü"
          :data="noteCategoryOptions"
          txt="title"
          val="id"
          width="20%"
          @change="onNoteCategoryChange"
          style="color: rgb(17, 17, 17)"
        />
        <r-select
          label="Kitap"
          :data="noteOptions"
          txt="name"
          val="id"
          :selectable="true"
          v-model:selected="noteIds"
          width="24%"
          style="color: rgb(17, 17, 17)"
        />
        <r-btn
          bgcolor="#1e88e5"
          class="r-ml-8"
          @click="loadList"
          :disabled="isLoading"
        >
          Filtre
        </r-btn>
        <r-btn
          bgcolor="#ff9800"
          class="r-ml-8"
          @click="clearDynamicFilters"
          :disabled="isLoading"
        >
          Dinamik Filtreyi Temizle
        </r-btn>
        <r-btn
          bgcolor="#0f6"
          class="r-ml-8"
          @click="exportPdf"
          :disabled="!list || list.length === 0 || isLoading"
        >
          PDF'e Aktar
        </r-btn>
      </template>
    </filter-bar>

    <!-- Sıra numarasından / soru numarasından hızlı bulmak için "Soruya Git" alanı -->
    <div class="r-flx r-mb-8" style="justify-content:flex-end;">
      <r-input v-model="qs" label="Soruya Git" width="15%" />
    </div>

    <table
      class="r-table"
      cellspacing="0"
      cellpadding="0"
      border="0"
      width="100%"
    >
      <thead>
        <tr>
          <th style="text-align:left;">Sıra</th>
          <th style="text-align:left;">S. No</th>
          <th style="text-align:left;">S. S. No</th>
          <th style="text-align:left;">Ay</th>
          <th style="text-align:left;">Yıl</th>
          <th style="text-align:left;">Vaka mı?</th>
          <th style="text-align:left;">Vaka</th>
          <th style="text-align:left;">Soru</th>
          <th style="text-align:left;">Şıklar</th>
          <th style="text-align:left;">Açıklama</th>
          <th style="text-align:left;">Tarih</th>
          <th style="text-align:left;">Referanslı mı?</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="q in filteredList" :key="q.id">
          <td>{{ q.__rowno }}</td>
          <td>{{ q.number }}</td>
          <td>{{ q.examNumber }}</td>
          <td>{{ q.workMonth }}</td>
          <td>{{ q.workYear }}</td>
          <td>{{ q.isCase ? "Evet" : "Hayır" }}</td>
          <td v-html="q.case"></td>
          <td v-html="q.detail"></td>
          <td v-html="formatChoices(q)"></td>
          <td v-html="formatDescription(q)"></td>
          <td v-html="formatDate(q.createDate)"></td>
          <td>
            <span
              class="r-check-ok small"
              v-if="q.isReferenced === true"
            ></span>
            <span class="r-check-no small" v-else></span>
          </td>
        </tr>
        <tr v-if="!list || list.length === 0">
          <td colspan="12">Kayıt bulunamadı.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref, computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { mxDate } from "@/mix/global";
import FilterBar from "@/components/FilterBar/FilterBar.vue";

export default {
  name: "PageSoruArsiv",
  components: {
    FilterBar
  },
  setup() {
    const store = useStore();
    const list = ref([]);
    const qs = ref("");
    const months = ref([]);
    const years = ref([]);
    const workMonth = ref("");
    const workYear = ref("");
    const isLoading = ref(false);
    const dynamicPropertyFilters = ref({});
    const filterBarRef = ref(null);

    // Yıl-Ay kombinasyonları (QuestionArchives/year-months)
    const yearMonthList = ref([]);
    const selectedYearMonth = ref(null);

    // Ortak soru filtreleri
    const questPart = ref(null);
    const questParts = ref([
      { txt: "Temel Bilimler", val: 1 },
      { txt: "Klinik Bilimler", val: 2 }
    ]);
    const branchId = ref(null);
    const branchList = ref({ data: [] });
    const subCategoryId = ref(null);
    const subCategoryList = ref({ data: [] });

    const notesCatsList = ref({ data: [] });
    const noteCategoryId = ref(null);
    const noteList = ref({ data: [] });
    // Çoklu kitap seçimi için dizi
    const noteIds = ref([]);

    // Seçim listelerine "Lütfen Seçiniz" opsiyonu ekleyen computed'lar
    const questPartOptions = computed(() => {
      const base = questParts.value || [];
      return [{ txt: "Lütfen Seçiniz", val: null }, ...base];
    });

    const yearMonthOptions = computed(() => {
      const arr = Array.isArray(yearMonthList.value) ? yearMonthList.value : [];
      return arr.map(x => ({ txt: x, val: x }));
    });

    const branchOptions = computed(() => {
      const arr =
        branchList.value && Array.isArray(branchList.value.data)
          ? branchList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const subCategoryOptions = computed(() => {
      const arr =
        subCategoryList.value && Array.isArray(subCategoryList.value.data)
          ? subCategoryList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const noteCategoryOptions = computed(() => {
      const arr =
        notesCatsList.value && Array.isArray(notesCatsList.value.data)
          ? notesCatsList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const noteOptions = computed(() => {
      const src = noteList.value || {};
      const arr = Array.isArray(src.data)
        ? src.data
        : Array.isArray(src.Data)
        ? src.Data
        : [];
      return [{ name: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const loadMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "QuestionArchives/months"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      months.value = Array.isArray(arr) ? arr : [];
    };

    const loadYears = async () => {
      const res = await store.dispatch("getDatas", {
        api: "QuestionArchives/years"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      years.value = Array.isArray(arr) ? arr : [];
    };

    const loadYearMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "QuestionArchives/year-months"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      yearMonthList.value = Array.isArray(arr) ? arr : [];
    };

    const ensureWorkFolder = async () => {
      // Archive distinct values drive defaults
      if (!workYear.value && years.value.length > 0)
        workYear.value = years.value[0];
      if (!workMonth.value && months.value.length > 0)
        workMonth.value = months.value[0];
    };

    const onYearMonthChange = e => {
      if (!e || !e.val) return;
      selectedYearMonth.value = e.val;
      const parts = e.val.split("-");
      if (parts.length === 2) {
        const [year, month] = parts;
        workYear.value = year;
        workMonth.value = month;
        loadList();
      }
    };

    const loadList = async () => {
      isLoading.value = true;
      try {
        // Dinamik property filtreleri: { [propDefId]: number[] } → düz listeye çevir
        const dynamicValues = dynamicPropertyFilters.value || {};
        const allValueIds = Object.values(dynamicValues)
          .reduce((acc, arr) => {
            if (Array.isArray(arr)) {
              return acc.concat(arr);
            }
            return acc;
          }, [])
          .filter((v, idx, arr) => arr.indexOf(v) === idx);

        const params = {
          workmonth: workMonth.value,
          workyear: workYear.value,
          page: 1,
          size: 100,
          order: 1
        };

        // Ek filtreler: soru çeşidi / branş / alt kategori / kitap türü / kitap(lar)
        // Öncelik sırası: alt kategori > branş > soru çeşidi
        if (questPart.value != null) {
          params.questPart = questPart.value;
        }
        // Alt kategori seçilmişse, sadece alt kategoriyi gönder (daha spesifik)
        // Alt kategori seçilmemişse ama branş seçilmişse, branşı gönder
        if (subCategoryId.value) {
          params.subCategoryId = subCategoryId.value;
        } else if (branchId.value) {
          params.branchId = branchId.value;
        }
        if (noteCategoryId.value) {
          params.noteCategoryId = noteCategoryId.value;
        }
        const uniqueNoteIds = Array.from(new Set(noteIds.value || []));
        if (uniqueNoteIds.length > 0) {
          params.noteIds = uniqueNoteIds.join(",");
        }

        if (allValueIds.length > 0) {
          // Backend şu an bu parametreyi kullanmıyor olabilir; şimdilik query'ye ekliyoruz.
          params.dynamicPropertyValueIds = allValueIds.join(",");
        }

        const res = await store.dispatch("getDatas", {
          api: "QuestionArchives/list",
          params
        });
        const arr = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.Data)
          ? res.Data
          : [];
        list.value = Array.isArray(arr)
          ? arr.map((x, i) => ({ ...x, __rowno: i + 1 }))
          : [];
      } finally {
        isLoading.value = false;
      }
    };

    const filteredList = computed(() => {
      if (!qs.value) return list.value || [];
      const term = String(qs.value).trim();
      if (!term) return list.value || [];
      return (list.value || []).filter(q => {
        const rowNo = q.__rowno != null ? String(q.__rowno) : "";
        const examNo = q.examNumber != null ? String(q.examNumber) : "";
        return rowNo.includes(term) || examNo.includes(term);
      });
    });

    const formatChoices = q => {
      const choices = [q.a, q.b, q.c, q.d, q.e];
      let str = "";
      choices.forEach((d, i) => {
        if (!d) return;
        if (d.startsWith && d.startsWith("<p>")) {
          str += `${d.slice(0, 3)}<strong>${
            store.state.choices[i]
          }) </strong>${d.slice(3)}`;
        } else {
          str += "<strong>" + store.state.choices[i] + ": </strong>" + d;
          if (i !== choices.length - 1) str += "<br>";
        }
      });
      return str;
    };

    const formatDescription = q => {
      let str = "<strong>Cevap:</strong> " + (q.answer || "") + "<br>";
      str += q.description || "";
      return str;
    };

    const formatDate = d => {
      return mxDate("dd-mm-yy-t", d, ".");
    };

    const buildQuestionHtml = (q, idx) => {
      const letter = i => store.state.choices[i];
      const choice = (c, i) => {
        if (!c) return "";
        if (c.startsWith && c.startsWith("<p>")) {
          return `${c.slice(0, 3)}<strong>${letter(i)}) </strong>${c.slice(3)}`;
        }
        return `<strong>${letter(i)}: </strong>${c}`;
      };
      const choices = [q.a, q.b, q.c, q.d, q.e];
      const choicesHtml = choices
        .map((c, i) => (c ? `<div class="choice">${choice(c, i)}</div>` : ""))
        .join("");
      return `
				<div class="q-item">
					<div class="q-head"><strong>Soru ${q.__rowno ||
            idx + 1}</strong> <span class="q-meta">(${q.workMonth ||
        ""} ${q.workYear || ""})</span></div>
					${q.isCase ? `<div class="q-case">${q.case || ""}</div>` : ""}
					<div class="q-detail">${q.detail || ""}</div>
					<div class="q-choices">${choicesHtml}</div>
				</div>
			`;
    };

    const buildPrintHtml = () => {
      const items = (list.value || [])
        .map((q, i) => buildQuestionHtml(q, i))
        .join("\n");
      const answers = buildAnswerHtml();
      return `<!doctype html><html><head><meta charset="utf-8" />
				<title>Soru Arşiv Çıktısı</title>
				<style>
					@page { size: A4; margin: 12mm; }
					body { font-family: Arial, Helvetica, sans-serif; color: #111; }
					.q-item { page-break-inside: avoid; margin-bottom: 14mm; }
					.q-head { margin-bottom: 6px; }
					.q-meta { color: #666; font-size: 12px; margin-left: 6px; }
					.q-case { margin-bottom: 6px; }
					.q-detail { margin-bottom: 8px; }
					.q-choices .choice { margin: 2px 0; }
					.answers { page-break-before: always; }
					.answers h2 { margin: 0 0 10mm 0; }
					.answers .ans-item { display: inline-block; width: 25%; box-sizing: border-box; padding: 2px 6px; font-size: 14px; }
				</style>
			</head><body>${items}${answers}</body></html>`;
    };

    const buildAnswerHtml = () => {
      const sorted = (list.value || [])
        .slice()
        .sort(
          (a, b) => (parseInt(a.__rowno) || 0) - (parseInt(b.__rowno) || 0)
        );
      const items = sorted
        .map(
          q =>
            `<div class="ans-item"><strong>${q.__rowno}.</strong> ${q.answer ||
              ""}</div>`
        )
        .join("");
      return `<div class="answers"><h2>Cevap Anahtarı</h2>${items}</div>`;
    };

    const exportPdf = () => {
      const html = buildPrintHtml();
      const w = window.open("", "_blank");
      if (!w) return;
      w.document.open();
      w.document.write(html);
      w.document.close();
      w.focus();
      setTimeout(() => {
        w.print();
        w.close();
      }, 200);
    };

    const onDynamicPropertyChange = payload => {
      // { propertyDefinitionId, selectedValues }
      if (!payload || payload.propertyDefinitionId == null) return;
      dynamicPropertyFilters.value = {
        ...dynamicPropertyFilters.value,
        [payload.propertyDefinitionId]: payload.selectedValues || []
      };
    };

    const clearDynamicFilters = () => {
      dynamicPropertyFilters.value = {};
      // FilterBar içindeki dinamik checkbox'ları da sıfırla
      if (
        filterBarRef.value &&
        typeof filterBarRef.value.resetDynamicProperties === "function"
      ) {
        filterBarRef.value.resetDynamicProperties();
      }
      // Listeyi dinamik filtreler olmadan yeniden yükle
      loadList();
    };

    // Ortak filtreler için yardımcı API çağrıları
    const getCatList = async (pid = 0) => {
      const res = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: { pid }
      });
      return res;
    };

    const getNoteCatsList = async () => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return res;
    };

    const getNotesByCategory = async (categoryId, notCategoryId) => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getnotesbycategoryandnotcatid",
        params: {
          categoryId: categoryId,
          isActive: true,
          notCategoryId: notCategoryId
        }
      });
      return res;
    };

    const onQuestPartChange = async e => {
      if (!e || e.val === undefined) return;
      questPart.value = e.val;

      // Tüm alt kategorileri al (pid=0)
      const result = await getCatList(0);
      if (result && result.data && Array.isArray(result.data)) {
        const filteredData = result.data.filter(item => {
          const parentId =
            item.parentId !== undefined ? item.parentId : item.ParentId;
          if (e.val === 1) {
            return parentId === 1;
          } else if (e.val === 2) {
            return parentId === 2;
          }
          return false;
        });
        branchList.value = { data: filteredData };
        branchId.value = null; // Seçimi kullanıcıya bırak
        subCategoryId.value = null; // Alt kategoriyi sıfırla
        subCategoryList.value = { data: [] }; // Alt kategori listesini temizle
      } else {
        branchList.value = { data: [] };
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };
      }
    };

    const onBranchChange = async e => {
      if (!e || e.id === undefined) return;
      branchId.value = e.id;

      // Seçilen branşın alt kategorilerini getir
      if (e.id) {
        const result = await getCatList(e.id);
        if (result && result.data && Array.isArray(result.data)) {
          subCategoryList.value = { data: result.data };
          subCategoryId.value = null; // Seçimi kullanıcıya bırak
        } else {
          subCategoryList.value = { data: [] };
          subCategoryId.value = null;
        }
      } else {
        subCategoryList.value = { data: [] };
        subCategoryId.value = null;
      }
    };

    const onNoteCategoryChange = async e => {
      if (!e || e.id === undefined) return;
      noteCategoryId.value = e.id;

      if (branchId.value && noteCategoryId.value) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
          noteList.value = { data: dataArray };
          // Varsayılan olarak ilk kitabı seçili yap (çoklu seçimde dizi olarak)
          const firstId = dataArray[0].id || null;
          noteIds.value = firstId !== null ? [firstId] : [];
        } else {
          noteList.value = { data: [] };
          noteIds.value = [];
        }
      } else {
        noteList.value = { data: [] };
        noteIds.value = [];
      }
    };

    onBeforeMount(async () => {
      // Yıl-Ay kombinasyonlarını yükle ve varsayılan seçimi yap
      await loadYearMonths();
      if (yearMonthList.value.length > 0) {
        const first = yearMonthList.value[0];
        selectedYearMonth.value = first;
        const parts = first.split("-");
        if (parts.length === 2) {
          const [year, month] = parts;
          workYear.value = year;
          workMonth.value = month;
        }
      } else {
        // Eski fallback mekanizması
        await loadMonths();
        await loadYears();
        await ensureWorkFolder();
      }

      // Ortak filtreler için başlangıç verilerini yükle
      const noteCats = await getNoteCatsList();
      notesCatsList.value = noteCats || { data: [] };

      const branchResult = await getCatList(0);
      if (
        branchResult &&
        branchResult.data &&
        Array.isArray(branchResult.data)
      ) {
        const filteredData = branchResult.data.filter(item => {
          const parentId =
            item.parentId !== undefined ? item.parentId : item.ParentId;
          // initial questPart: 1 (Temel)
          return parentId === 1;
        });
        branchList.value = { data: filteredData };
        branchId.value = null; //filteredData.length > 0 ? filteredData[0].id : null
      }

      await loadList();
    });

    return {
      list,
      qs,
      filteredList,
      months,
      years,
      workMonth,
      workYear,
      isLoading,
      dynamicPropertyFilters,
      filterBarRef,
      yearMonthList,
      selectedYearMonth,
      yearMonthOptions,
      loadList,
      formatChoices,
      formatDescription,
      formatDate,
      exportPdf,
      onDynamicPropertyChange,
      questPart,
      questParts,
      questPartOptions,
      branchId,
      branchList,
      branchOptions,
      subCategoryId,
      subCategoryList,
      subCategoryOptions,
      notesCatsList,
      noteCategoryId,
      noteList,
      noteIds,
      noteCategoryOptions,
      noteOptions,
      onYearMonthChange,
      onQuestPartChange,
      onBranchChange,
      onNoteCategoryChange,
      clearDynamicFilters
    };
  }
};
</script>

<style scoped>
h2 {
  margin: 0 0 12px 0;
}
DetailModifield.r-table {
  border-collapse: collapse;
  border: 1px solid #e0e0e0;
}
.r-table th,
.r-table td {
  padding: 8px;
  border: 1px solid #e6e6e6;
}
.r-table thead th {
  background: #f7f7f7;
  font-weight: 600;
}
.r-table tbody tr:nth-child(even) {
  background: #fafafa;
}
</style>
